import { saleService } from "../../services/modules/sale.service";
import { getAccessToken } from "../../services/http/tokenStore";
import { API_BASE } from "../../services/http/endpoints";
import { store } from "../../store";
import { getSalesDraftStorageKeyFromPath, isSalesRoutePath } from "../../state/salesDraftUtils";

const releaseUrl = (suffix) => `${API_BASE.replace(/\/+$/, "")}/api/sales/reservations/${suffix}/`;

export const collectActiveSaleIdsFromTabs = (tabs = [], drafts = {}) => {
  const saleIds = [];
  tabs.forEach((tab) => {
    const path = tab?.path;
    if (!isSalesRoutePath(path)) return;
    const draftKey = getSalesDraftStorageKeyFromPath(path);
    const draft = draftKey ? drafts[draftKey] : null;
    const saleId = Number(draft?.sale?.id || 0);
    const hasItems = Number(draft?.sale?.items?.length || 0) > 0;
    if (saleId > 0 && hasItems && !saleIds.includes(saleId)) {
      saleIds.push(saleId);
    }
  });
  return saleIds;
};

export const releaseSaleIds = async (saleIds = [], branchId = null) => {
  const uniqueIds = Array.from(new Set(saleIds.map((id) => Number(id)).filter((id) => id > 0)));
  await Promise.all(
    uniqueIds.map((saleId) =>
      saleService.releaseReservations({ sale_id: saleId, branch_id: branchId || undefined }).catch(() => null)
    )
  );
};

export const releaseAllUserReservations = async (branchId = null) => {
  return saleService.releaseAllReservations({ branch_id: branchId || undefined }).catch(() => null);
};

export const releaseAllUserReservationsSync = (branchId = null) => {
  const token = getAccessToken();
  if (!token || typeof fetch !== "function") return;
  const body = JSON.stringify({ branch_id: branchId || undefined });
  fetch(releaseUrl("release-all"), {
    method: "POST",
    body,
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).catch(() => {});
};

export const releaseActiveSalesFromStore = async (branchId = null) => {
  const state = store.getState();
  const saleIds = collectActiveSaleIdsFromTabs(state.tabs?.tabs || [], state.salesDrafts?.drafts || {});
  await releaseSaleIds(saleIds, branchId);
};

export const getActiveSaleIdsFromStore = () => {
  const state = store.getState();
  return collectActiveSaleIdsFromTabs(state.tabs?.tabs || [], state.salesDrafts?.drafts || {});
};

export const hasActiveSalesInStore = () => getActiveSaleIdsFromStore().length > 0;
